// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__EkX_j","header":"MessagesList_header__33t8X","chat":"MessagesList_chat__44iEU"};